var $window = $(window);
var breakPoint = 768;

var resizeFlag = false;
var windowWidth = $window.width();
var windowHeight = $window.height();

//ページ内リンクのアニメーション
import {anchorScroll} from "../include/module";
anchorScroll();

//ページTOP
import {pageTop} from "../include/module";
pageTop();

//外部ページからのアンカー
import {externalAnchor} from "../include/module";
externalAnchor();

//SPヘッダーの開閉
import {spHeaderToggle} from "../include/module";
spHeaderToggle();

//ヘッダースクロール
import {headerClass} from "../include/module";
headerClass();

//スライダー
$('.slider').slick({
  centerMode: true,
  autoplay: true,
  variableWidth: true,
  dots: true,
  responsive: [
    {
      breakpoint: 768,
      settings: {
      }
    },
    {
      breakpoint: 480,
      settings: {
      }
    }
  ]
});


// WEBPACK FOOTER //
// script.js